import React from "react";
import "../styles/Slots.css";

function OnlineClassSlots() {
  return (
    <main className="material-page">
      <section className="section section-surface">
        <div className="container slots-container">
          <div className="slots-header">
            <div>
              <p className="eyebrow">ONLINE CLASSES</p>
              <h2>Online booking is coming soon</h2>
              <p className="slots-empty">
                We are preparing a new booking experience. Please check back soon.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default OnlineClassSlots;
